<template>
	<div class="policySecretary">
		<!--政策小秘书启动-->
		<div class="secretary-switch">
			<div class="label">
				政策小秘书提醒服务
			</div>
			<van-switch v-model="checked" @change="changeCheck"/>
		</div>
		<van-divider />
		<!--政策小秘书列表数据-->
		<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedText"
			@load="onLoad"
		>
			<div class="policy-list" v-for="(info,index) in dataList" :key="index">
				<div class="policy-list-title">
					<div class="l">
						{{ info.matchDate }}
					</div>
				</div>
				<ul class="policy-list" v-for="(item, index) in info.policy" :key="index">
					<li @click="goDetail(item)">
						<div class="libox">
							<div class="libox-l">
								<div class="t">{{ item.policyName }}</div>
								<div class="policylabel">
									<span class="yellow" v-if="item.lastDays > 0">剩余{{item.lastDays}}天</span>
									<!--<span class="yellow" v-else>已过期</span>-->
									<span class="green">{{item.department}}</span>
								</div>
								<div class="time">申报时间：
									<span v-if="item.startDate || item.endDate">{{item.startDate}}{{ item.startDate&&item.endDate ? '～' : '' }}{{item.endDate}}</span>
									<span v-else>待定</span>
								</div>
							</div>
							<div class="libox-r">
								<p class="scores">匹配度<span>{{item.matchScore}}分</span></p>
								<div class="apply-price">
									<p v-if="item.policyTypeId === 2" class="lab">最高可减免</p>
									<p v-else class="lab">最高可申报</p>
									<p class="price"><span>{{item.maxSubsidy}}</span>{{item.maxSubsidyUnit}}</p>
								</div>
							</div>
							<span class="tip" v-if="!item.isRead"></span>
						</div>
					</li>
				</ul>
			</div>
		</van-list>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { reqSecretaryPolicy } from '../../../api';

	export default {
		name: 'PolicySecretary',
		data() {
			return {
				checked: false,
				dataList: [],
				page: 1, // 当前页
				size: 10, // 每页大小
				loading: false,
				finished: false
			}
		},
		computed: {
			...mapGetters(['policySecretary']),
			finishedText: {
				get(){
					return this.finished === true ? '没有更多了' : ''
				},
				set(){
				}
			}
		},
		created () {
			this.checked = !!this.policySecretary
			this.getSecretaryPolicy()
		},
		methods: {
			// 获取政策小秘书列表
			getSecretaryPolicy(){
				let params = {
					channel: 3,
					page: this.page,
					size: this.size
				}
				this.loading = true
				reqSecretaryPolicy(params).then( res => {
					let policyList =  res.data
					if(policyList.length < this.size){
						this.finished =  true
					}
					this.dividePolicy(policyList)
					this.loading = false
				})
			},
			// 是和否开启通知
			changeCheck() {
				this.$emit('changeChecked', +this.checked)
			},
			// 按时间分组
			dividePolicy(arr){
				arr.forEach((item) => {
					let index = -1;
					let alreadyExists = this.dataList.some((newitem, j) => {
						if (item.matchDate === newitem.matchDate) {
							index = j;
							return true;
						}
					});
					let policyObj = {
						"department": item.department,
						"endDate": item.endDate,
						"isRead": item.isRead,
						"lastDays": item.lastDays,
						"matchDate": item.matchDate,
						"matchScore": item.matchScore,
						"maxSubsidy": item.maxSubsidy,
						"policyId": item.policyId,
						"policyName": item.policyName,
						"policyTypeId": item.policyTypeId,
						"startDate": item.startDate,
						"maxSubsidyUnit": item.maxSubsidyUnit
					}
					if (!alreadyExists) {
						this.dataList.push({
							matchDate: item.matchDate.replace(/-/g, '.'),
							policy:[policyObj]
						})
					} else {
						this.dataList[index].policy.push(policyObj);
					}
				});
			},
			// 列表加载
			onLoad() {
				this.page++
				this.getSecretaryPolicy()
			},
			// 刷新数据
			// refresh(){
			// 	this.loading= false
			// 	this.finished = false
			// 	this.page = 1
			// 	this.dataList = []
			// 	this.getSecretaryPolicy()
			// }
			// 跳转详情
			goDetail(item) {
				// eslint-disable-next-line
				sensors.track('policyClick', {
					policy_id: item.policyId,
					policy_name: item.policyName,
					policy_show_type: "非模糊",
					match_level: item.matchScore,
					policy_department: item.department,
					max_declare: item.maxSubsidy
				})
				this.$router.push({
					path: '/detail',
					query: {
						policyId: item.policyId,
						from: 'vip'
					}
				})
			},
		},
	};
</script>

<style lang="less" scoped>
	.policySecretary {
		margin-top:15px;
		padding: 0 16px;
		.secretary-switch {
			display: flex;
			align-items: center;
			justify-content: space-between;
			.label {
				font-size: 12px;
			}
		}
		/* 列表样式 */
		.policy-list {
			.policy-list-title {
				font-size:20px;
				font-family: PingFangSC-Medium,PingFang SC;
				font-weight:500;
				color:rgba(0,0,0,1);
				line-height:20px;
				margin-bottom: 16px;
			}
			li {
				.libox {
					padding: 16px;
					box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
					border-radius:5px;
					margin-bottom: 16px;
					position: relative;
					display: flex;
					.tip {
						display: inline-block;
						position: absolute;
						top: 5px;
						left: 5px;
						width: 10px;
						height: 10px;
						background: #FA5151;
						border:1px solid rgba(255,255,255,1);
						border-radius: 50%;
					}
					.libox-l {
						flex: 1;
					}
					.libox-r {
						width: 90px;
						display: flex;
						justify-content: space-around;
						flex-direction: column;
						text-align: center;
						.apply-price {
							background:rgba(255,255,255,1);
							box-shadow:0px 0px 10px 0px rgba(0,0,0,0.05);
							border-radius:4px;
						}
					}
					.t {
						font-size: 16px;
						font-weight: bold;
						color: #333;
						line-height: 22px;
					}
					.time {
						font-size: 12px;
						color: @blue;
					}
					.gray {
						color: #999999;
					}
					.libox-r {
						.scores {
							font-size: 12px; line-height: 18px; color: #999;
							span { color: @yellow;}
						}
						.lab {
							line-height:22px;
							background:rgba(235,243,255,1);
							border-radius:4px 4px 0px 0px;
							margin: 0 0 12px 0px;
							font-size: 12px;
							color: @blue;
							padding: 0 10px;
						}
						.price {
							font-size: 12px; color: @priceColor;
							font-family: DINCondensedBold;
							span { font-size: 24px; }
						}
					}
					.iconfont {
						position: absolute;
						font-size: 12px;
						top: 50%;
						margin-top: -6px;
						right: 16px;
						color: #ccc;
					}
				}
			}
		}
		.policylabel {
			margin: 10px 0 15px;
			display: flex;
			flex-wrap: wrap;
			span {
				display: block;
				line-height: 22px;
				padding: 0 8px;
				margin: 0 5px 5px 0;
				font-size: 12px;
				border-radius: 3px;
				max-width: 100px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
			}
			.yellow {
				background: #FDF5EA;
				color: @yellow;
			}
			.green {
				background: @lightGreen;
				color: @green;
			}
			.red {
				background: #FEEDED;
				color: @priceColor;
			}
			.gray {
				background: #F5F5F5;
				color: #999999;
			}
		}
	}

</style>
